<template>  
  <div class="buttons" id="health-filter">
    <span 
    v-for="(label, key) in SHIPMENTS_HEALTH" :key="key" 
    class="button is-small round" 
    @click="toggleFilter(key)"
    :class="{'is-selected': target == key, [key]: true}">
      <span>{{ label }}</span>
    </span>
  </div>
</template>

<script>
import TrackingRequest from '@/models/trackingRequest'
export default {
  name: 'health-filter',
  props: ['data'],
  data () {
    return {
      target: '',
      SHIPMENTS_HEALTH: TrackingRequest.SHIPMENTS_HEALTH
    }
  },
  methods: {
    toggleFilter (key) {
      if (this.target === key) {
        this.target = ''
      } else {
        this.target = key
      }
    }
  },
  watch: {
    data: {
      handler () {
        if (this.target !== this.data) {
          this.target = this.data
        }
      },
      deep: true,
      immediate: true
    },
    target () {
      if (this.target !== this.data) {
        this.$emit('change', this.target)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.round {
  text-transform: uppercase;
  font-family: MuseoSans-900;
  color:white;
}
.ontrack {
   background: #90be6f;
   &.is-selected{border:3px solid #5ca849;}
}
.delayed {
  background: #ffb346;
  &.is-selected{border:3px solid #e7852a;}
}
.alerted {
  background: #e73857;
  &.is-selected{border:3px solid #b40d3f;}
}
</style>



// WEBPACK FOOTER //
// src/components/HealthFilter.vue